import { render } from "./Projects.vue?vue&type=template&id=109cff18"
import script from "./Projects.vue?vue&type=script&setup=true&lang=js"
export * from "./Projects.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/Projects.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "109cff18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('109cff18', __exports__)) {
    console.log('reload')
    api.reload('109cff18', __exports__)
  }
  
  module.hot.accept("./Projects.vue?vue&type=template&id=109cff18", () => {
    console.log('re-render')
    api.rerender('109cff18', render)
  })

}


export default __exports__